import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase"; // make sure this path is correct
import "../styles/HireTalent.css";

export default function HireTalent() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
    skills: "",
    experience: "",
    resume: "",
    interest: "",
  });

  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      await addDoc(collection(db, "talentProfiles"), {
        ...formData,
        createdAt: serverTimestamp(),
      });

      alert("Thank you! Our team will contact you shortly.");

      setFormData({
        name: "",
        email: "",
        phone: "",
        role: "",
        skills: "",
        experience: "",
        resume: "",
        interest: "",
      });

    } catch (error) {
      console.error("Error submitting profile:", error);
      alert("Something went wrong. Please try again.");
    }

    setLoading(false);
  }

  return (
    <div className="hire-page">

      {/* ================= HERO ================= */}
      <section className="hire-hero">
        <div className="hire-hero-content">
          <h1>Hire & Place Industry-Ready Talent</h1>
          <p>
            Sprout Knowledge Solutions collects verified student profiles,
            evaluates skills, builds resumes, and supports candidates until
            they get hired.
          </p>
        </div>
      </section>

      {/* ================= HOW IT WORKS ================= */}
      <section className="hire-section">
        <h2>How Sprout Helps Students Get Hired</h2>

        <div className="hire-grid">
          <div className="hire-card">
            <h3>📋 Profile Collection</h3>
            <p>
              We collect education details, career goals, preferred roles,
              and availability from students.
            </p>
          </div>

          <div className="hire-card">
            <h3>🧠 Skill Assessment</h3>
            <p>
              Technical skills, aptitude, and communication are evaluated
              before shortlisting.
            </p>
          </div>

          <div className="hire-card">
            <h3>📄 Resume & Portfolio</h3>
            <p>
              ATS-friendly resumes, GitHub, LinkedIn, and project portfolios
              are prepared.
            </p>
          </div>

          <div className="hire-card">
            <h3>🎯 Job Placement</h3>
            <p>
              Interview training, referrals, and placement support until
              students get hired.
            </p>
          </div>
        </div>
      </section>

      {/* ================= TALENT FORM ================= */}
      <section className="hire-section light">
        <h2>Submit Your Profile</h2>
        <p className="section-desc">
          Students & job seekers can register their details below.
          Our team will review your profile and guide you toward job opportunities.
        </p>

        <form className="hire-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label>Full Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your full name"
                required
              />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter mobile number"
                required
              />
            </div>

            <div className="form-group">
              <label>Preferred Job Role</label>
              <input
                type="text"
                name="role"
                value={formData.role}
                onChange={handleChange}
                placeholder="Frontend / Backend / Full Stack"
                required
              />
            </div>

            <div className="form-group">
              <label>Key Skills</label>
              <input
                type="text"
                name="skills"
                value={formData.skills}
                onChange={handleChange}
                placeholder="HTML, CSS, JS, React, Python..."
                required
              />
            </div>

            <div className="form-group">
              <label>Experience Level</label>
              <select
                name="experience"
                value={formData.experience}
                onChange={handleChange}
                required
              >
                <option value="">Select experience</option>
                <option>Student / Fresher</option>
                <option>0–1 Years</option>
                <option>1–3 Years</option>
                <option>3+ Years</option>
              </select>
            </div>

            <div className="form-group">
              <label>Resume / Portfolio Link</label>
              <input
                type="text"
                name="resume"
                value={formData.resume}
                onChange={handleChange}
                placeholder="Google Drive / GitHub / Portfolio URL"
              />
            </div>

            <div className="form-group">
              <label>Career Interest</label>
              <textarea
                name="interest"
                value={formData.interest}
                onChange={handleChange}
                placeholder="Tell us your career goals"
                rows="3"
              ></textarea>
            </div>
          </div>

          <button type="submit" className="primary-btn" disabled={loading}>
            {loading ? "Submitting..." : "Submit Profile"}
          </button>
        </form>
      </section>

      {/* ================= CTA ================= */}
      <section className="hire-cta">
        <h2>From Skill Building to Job Placement</h2>
        <p>
          Sprout Knowledge Solutions supports students from learning
          to employment with structured guidance and hiring connections.
        </p>
      </section>

    </div>
  );
}